export var ActivityType;
(function (ActivityType) {
  ActivityType["ADDED"] = "added";
  ActivityType["DELETED"] = "deleted";
  ActivityType["MODIFIED"] = "modified";
  ActivityType["COMPOSITE"] = "composite";
})(ActivityType || (ActivityType = {}));